import React from 'react';
import { BodyText, Button, Grid } from 'ui-toolkit';

interface IDuplicateMessageProps {
  duplicateMessage?: string;
}

export const DuplicateContactMessage: React.FC<IDuplicateMessageProps> = ({ duplicateMessage }) => {
  return (
    <Grid textAlign={'center'}>
      <BodyText>{duplicateMessage ? duplicateMessage : 'Contact with that name has already been added.'}</BodyText>
      <Button intent={'primary'} type={'reset'}>
        Ok
      </Button>
    </Grid>
  );
};
